import { combineReducers } from 'redux'
import misc from './misc'
import teams from './teams'

export default combineReducers({
  misc,
  teams,
})
